__turbopack_context__.v({
  "iframe": "error-module__znQwMa__iframe",
});
